import BackIcon from 'assets/images/rectangle/Back_black.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import CustomDropDown from 'components/dropDown'
import {
    FiArrowDownCircle,
    FiArrowUpCircle,
    FiBarChart2,
    FiFileText,
    FiPlayCircle,
    FiShare2,
    FiSettings,
    FiLink2,
    FiLogOut,
    FiBell,
} from 'react-icons/fi'
import posthog from 'posthog-js'
import { useState } from 'react'
import CustomBottomSheet from 'components/bottomSheet'
import Share from '../share'
import JoinLink from '../joinLink'
interface IHeaderProps {
    exist: number
    hamyanBalance: number
    bankBalance: string
    inprogress: number
    balance: number
    showBalance: boolean
    poolShipId: number | undefined
    role: string
    setIsOpenExcelModal: React.Dispatch<React.SetStateAction<boolean>>
    isFuckingManager: () => boolean
    name: string
    servicePackage: number
    trustedState: string
    hiddenFinanceDetail: boolean
}
export default function Header({
    exist,
    hamyanBalance,
    bankBalance,
    inprogress,
    balance,
    showBalance,
    poolShipId,
    role,
    name,
    isFuckingManager,
    setIsOpenExcelModal,
    servicePackage,
    trustedState,
    hiddenFinanceDetail,
}: IHeaderProps) {
    const [shareBottomSheet, setShareBottomSheet] = useState<boolean>(false)
    const [joinLinkBottomSheet, setJoinLinkBottomSheet] =
        useState<boolean>(false)
    const navigate = useNavigate()
    const { id } = useParams()
    const isNormal = !isFuckingManager()
    // موجودی پنهان برای عضو عادی وقتی مدیر show_box_balance را بسته
    const balanceHidden = isNormal && !showBalance
    const balanceColor = balance > 0 ? '#1B8A3F' : '#F44336'
    // trust_state سه حالت بج دارد؛ trst (مطمئن) اصلاً بج ندارد
    const trustBadge =
        trustedState === 'wdvf'
            ? { text: 'متصل به حساب مدیر', bg: '#74B743', fg: '#FFFFFF' }
            : trustedState === 'wduv'
            ? {
                  text: 'عدم تأیید اتصال به حساب مدیر',
                  bg: '#F44336',
                  fg: '#FFFFFF',
              }
            : trustedState === 'wdip'
            ? {
                  text: 'در حال اتصال به حساب مدیر',
                  bg: '#FFCC00',
                  fg: '#000000',
              }
            : null

    return (
        <>
            {/* Toolbar — ?actionBarSize (56px) white bar with 1px bottom hairline */}
            <div className="relative h-14 w-full bg-white border-b border-[#EFEFEF]">
                {/* Package badge (yellow CardView, 15dp radius, pulled up -15dp,
                    hangs beside the 50dp back tap-area) */}
                <div className="absolute -top-[15px] right-[50px] z-10">
                    <div className="w-[50px] rounded-[15px] bg-[#FFCC00] shadow-badge px-2 pt-5 pb-2.5">
                        <p className="text-center text-[10px] text-black">
                            {servicePackage === 1
                                ? 'اشتراکی'
                                : servicePackage === 2
                                ? 'رایگان'
                                : 'کارمزدی'}
                        </p>
                    </div>
                </div>

                {/* Trust-state badge (CardView, 15dp radius, pulled up -15dp,
                    hangs beside the 50dp settings tap-area). Android: wdvf=green,
                    wduv=red, wdip=yellow/black, trst=no badge */}
                {trustBadge && (
                    <div className="absolute -top-[15px] left-[50px] z-10">
                        <div
                            className="w-[60px] rounded-[15px] shadow-badge px-2 pt-[18px] pb-1.5"
                            style={{ backgroundColor: trustBadge.bg }}
                        >
                            <p
                                className="text-center text-[10px] leading-tight"
                                style={{ color: trustBadge.fg }}
                            >
                                {trustBadge.text}
                            </p>
                        </div>
                    </div>
                )}

                {/* Center: title + balance dropdown. Hidden entirely for a normal
                    member when hidden_finance_detail; shows «-» when balance hidden */}
                {!(isNormal && hiddenFinanceDetail) && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                        <p className="text-[12px] text-black leading-none">
                            موجودی صندوق
                        </p>
                        <Dropdown>
                            <Dropdown.Toggle
                                style={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    boxShadow: 'none',
                                    padding: '0px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {/* chevron sits LEFT of the amount (Android
                                    renders force-LTR: arrow then value) —
                                    in RTL DOM the last child lands leftmost */}
                                <span className="flex items-center gap-1 text-[16px] font-bold text-black">
                                    {balanceHidden ? (
                                        <span style={{ color: balanceColor }}>
                                            -
                                        </span>
                                    ) : (
                                        <>
                                            <span
                                                style={{ color: balanceColor }}
                                            >
                                                {exist
                                                    ? exist.toLocaleString()
                                                    : 0}
                                            </span>{' '}
                                            تومان
                                        </>
                                    )}
                                    <svg
                                        className="w-3 h-3"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                style={{
                                    backgroundColor: '#048192',
                                    padding: '8px 24px',
                                    width: '230px',
                                    border: 'none',
                                    borderRadius: '16px',
                                }}
                                id="dropdown-center"
                            >
                                <div className="text-right text-base text-white">
                                    <p className="my-1">موجودی نزد همیان:</p>
                                    <p className="my-1 pr-3">
                                        {balanceHidden
                                            ? '-'
                                            : `${(
                                                  hamyanBalance || 0
                                              ).toLocaleString()} تومان`}
                                    </p>
                                    <p className="my-1">موجودی نزد مدیر:</p>
                                    <p className="my-1 pr-3">
                                        {balanceHidden
                                            ? '-'
                                            : `${Number(
                                                  bankBalance || 0
                                              ).toLocaleString()} تومان`}
                                    </p>
                                    <p className="my-1">
                                        در حال واریز به حساب صندوق:
                                    </p>
                                    <p className="my-1 pr-3">
                                        {balanceHidden
                                            ? '-'
                                            : `${Number(
                                                  inprogress || 0
                                              ).toLocaleString()} تومان`}
                                    </p>
                                    <p className="my-1">مجموع موجودی:</p>
                                    <p className="my-1 pr-3">
                                        {balanceHidden
                                            ? '-'
                                            : `${Number(
                                                  balance || 0
                                              ).toLocaleString()} تومان`}
                                    </p>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}

                {/* Back button — 16dp, far right, vertically centered, marginRight 14dp */}
                <img
                    src={BackIcon}
                    alt="back-icon"
                    onClick={() => navigate(-1)}
                    className="absolute right-[14px] top-1/2 -translate-y-1/2 w-4 h-4 cursor-pointer"
                />

                {/* Options menu — far left (settings slot, marginStart 16dp) */}
                <div className="absolute left-4 top-1/2 -translate-y-1/2">
                    {/* Android menu_moneypool_detail_options.xml: white card,
                        10dp radius, 1dp #EFEFEF stroke, 8dp v-padding; every
                        row has a 20dp icon pinned to the RIGHT with the bold
                        #575756 label to its left */}
                    <CustomDropDown listWrapperClassName="min-w-[210px] rounded-[10px] border border-[#EFEFEF] bg-white py-2 shadow-[0_4px_20px_rgba(0,0,0,0.12)]">
                        <div className="text-sm font-bold text-text-body text-right">
                            {isFuckingManager() && (
                                <>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() =>
                                            navigate(`/fund/plans/${id}`, {
                                                state: {
                                                    name,
                                                    servicePackage,
                                                },
                                            })
                                        }
                                    >
                                        <FiArrowUpCircle className="h-5 w-5 shrink-0" />
                                        خرید اشتراک
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() =>
                                            setIsOpenExcelModal(true)
                                        }
                                    >
                                        <FiFileText className="h-5 w-5 shrink-0" />
                                        دریافت اکسل گزارش صندوق
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() =>
                                            navigate(
                                                `/fund/financial-dashboard/${id}`,
                                                { state: { name } }
                                            )
                                        }
                                    >
                                        <FiFileText className="h-5 w-5 shrink-0" />
                                        داشبورد هزینه و درآمد
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() => {
                                            posthog.capture(
                                                'admin_dashboard_menu_clicked',
                                                { moneypool_id: id }
                                            )
                                            navigate(
                                                `/fund/admin-dashboard/${id}`
                                            )
                                        }}
                                    >
                                        <FiBarChart2 className="h-5 w-5 shrink-0" />
                                        داشبورد مدیریت
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() => {
                                            posthog.capture(
                                                'withdrawal_requests_list_viewed',
                                                {
                                                    moneypool_id: id,
                                                    source: 'kebab',
                                                }
                                            )
                                            navigate(
                                                `/fund/withdrawal-requests/${id}`
                                            )
                                        }}
                                    >
                                        <FiArrowDownCircle className="h-5 w-5 shrink-0" />
                                        درخواست‌های برداشت
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() => {
                                            posthog.capture(
                                                'flow_replay_menu_clicked',
                                                { moneypool_id: id }
                                            )
                                            navigate(`/fund/flow-replay/${id}`)
                                        }}
                                    >
                                        <FiPlayCircle className="h-5 w-5 shrink-0" />
                                        بازپخش گردش صندوق
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() =>
                                            setShareBottomSheet(true)
                                        }
                                    >
                                        <FiShare2 className="h-5 w-5 shrink-0" />
                                        لینک پرداخت صندوق
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() =>
                                            navigate(`/fund/setting/${id}`)
                                        }
                                    >
                                        <FiSettings className="h-5 w-5 shrink-0" />
                                        تنظیمات صندوق
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() => {
                                            posthog.capture(
                                                'fund_invite_link_opened',
                                                { fund_id: id }
                                            )
                                            setJoinLinkBottomSheet(true)
                                        }}
                                    >
                                        <FiLink2 className="h-5 w-5 shrink-0" />
                                        لینک عضویت در صندوق
                                    </p>
                                    <p
                                        className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                        onClick={() => {
                                            posthog.capture(
                                                'announce_to_members_menu_clicked',
                                                { moneypool_id: id }
                                            )
                                            navigate(`/fund/announce/${id}`)
                                        }}
                                    >
                                        <FiBell className="h-5 w-5 shrink-0" />
                                        اطلاع‌رسانی به اعضا
                                    </p>
                                </>
                            )}
                            <p
                                className="flex cursor-pointer items-center gap-2 px-4 py-2"
                                onClick={() => {
                                    isFuckingManager()
                                        ? navigate(
                                              `/fund/admin-settlement-exit/${id}`
                                          )
                                        : navigate(
                                              `/fund/settlement-exit/${id}`,
                                              { state: { poolShipId } }
                                          )
                                }}
                            >
                                <FiLogOut className="h-5 w-5 shrink-0" />
                                {isFuckingManager()
                                    ? 'درخواست‌های تسویه و خروج'
                                    : 'درخواست تسویه و خروج'}
                            </p>
                        </div>
                    </CustomDropDown>
                </div>
            </div>
            <CustomBottomSheet
                isOpen={shareBottomSheet}
                onDismiss={() => setShareBottomSheet(false)}
            >
                <Share />
            </CustomBottomSheet>
            <CustomBottomSheet
                isOpen={joinLinkBottomSheet}
                onDismiss={() => setJoinLinkBottomSheet(false)}
            >
                <JoinLink />
            </CustomBottomSheet>
        </>
    )
}
